import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import InvoiceFormWizard from './Invoices/components/InvoiceFormWizard';

export default function InvoiceEditPage() {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <InvoiceFormWizard
      isOpen={true}
      onClose={() => navigate(id ? `/invoices/${id}` : '/invoices')}
      invoiceId={id}
      presentation="page"
    />
  );
}
